{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name}: {value}",
  "colorPicker": "Värimuokkain",
  "colorSwatch": "värimalli",
  "transparent": "läpinäkyvä",
  "twoDimensionalSlider": "2D-liukusäädin"
}
